import { render, staticRenderFns } from "./CulturePage.vue?vue&type=template&id=40dd3022&scoped=true&"
import script from "./CulturePage.vue?vue&type=script&lang=js&"
export * from "./CulturePage.vue?vue&type=script&lang=js&"
import style0 from "./CulturePage.vue?vue&type=style&index=0&id=40dd3022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dd3022",
  null
  
)

export default component.exports